export default __webpack_public_path__ + "static/media/intebot-logo.0ba97daa.png";